/**
 * The Online Documentation guides: dialog title + a loader per topic.
 *
 * Titles are legacy's own top headings (helperSection/*.vue <h2>), shown as
 * the dialog title instead of inside the text. Each guide is a dynamic
 * import, so it is its own chunk, fetched only when the dialog opens.
 * Which topic belongs to which page: ../helpTopics.js.
 */
export const HELP_TOPICS = Object.freeze({
  eiaManagePortfolio: {
    title: 'Manage Portfolio',
    load: () => import('./EiaManagePortfolio'),
  },
  eiaCostAdvice: {
    title: 'Instance Advice',
    load: () => import('./EiaCostAdvice'),
  },
  ccaManagePortfolio: {
    title: 'Manage Portfolio',
    load: () => import('./CcaManagePortfolio'),
  },
  ccaCostAdvice: {
    title: 'Cost Advice',
    load: () => import('./CcaCostAdvice'),
  },
  explorer: {
    title: 'Explorer',
    load: () => import('./Explorer'),
  },
  cloudReports: {
    title: 'Cloud Usage Reports',
    load: () => import('./CloudReports'),
  },
  datadog: {
    title: 'Add Instances via Telemetry Connector (Datadog)',
    load: () => import('./Datadog'),
  },
  cloudwatch: {
    title: 'Add Instances via Telemetry Connector (AWS CloudWatch)',
    load: () => import('./CloudWatch'),
  },
  azureInsights: {
    title: 'Add Instances via Telemetry Connector (Azure App Insights)',
    load: () => import('./AzureInsights'),
  },
  gcpTelemetry: {
    title: 'Add Instances via Telemetry Connector (Google Cloud Ops Agent)',
    load: () => import('./GcpTelemetry'),
  },
  prometheus: {
    title: 'Add Instances via Telemetry Connector (Prometheus)',
    load: () => import('./Prometheus'),
  },
});
